export default function Programs() {
    const programs = [
  {
    title: "Beginner Coaching",
    desc: "Basic cricket training for beginners focusing on fundamentals, techniques, and game understanding.",
  },
  {
    title: "Advanced Training",
    desc: "High-level coaching for experienced players including match strategies, skill development, and performance improvement.",
  },
  {
    title: "Fitness & Conditioning",
    desc: "Special fitness programs designed for all age groups to improve strength, stamina, agility, and overall performance.",
  },
];
  return (
    
    <section id="programs" className="p-16 bg-gray-100">
        
      <h2 className="text-2xl font-bold">Programs</h2>
      <div className="grid md:grid-cols-3 gap-6">
  {programs.map((p, i) => (
    <div key={i} className="bg-white p-6 rounded-2xl shadow hover:scale-105 transition">
      <h3 className="text-xl font-semibold">{p.title}</h3>
      <p className="mt-2 text-gray-600">{p.desc}</p>
    </div>
  ))}
</div>
    </section>
  );
}